import errorBoundary from '@ifeng/errorBoundary';
import PropTypes from 'prop-types';
import React from 'react';
import { jsonp } from '@ifeng/ui_base';
import styles from './index.css';

const getQrCode = async url => {
    return await jsonp(`//qrcode.ifeng.com/qrcode.php?url=${url}?_share=weixin`, {
        jsonpCallback: 'getQrCode',
        cache: false,
    });
};

class Pc extends React.PureComponent {
    // static propTypes = {
    //     qrcodeUrl: PropTypes.string,
    // };

    state = {
        qrcodeUrl: '',
    };

    async componentDidMount() {
        // 获取分享二维码
        const qrcodeData = await getQrCode(location.href);

        this.setState({
            qrcodeUrl: qrcodeData.qrcode_url || '',
        });
    }

    render() {
        const { qrcodeUrl } = this.state;

        return (
            <div className={styles.pcBox}>
                <div className={styles.pcBody}>
                    <img className={styles.pcBoxImg} src={qrcodeUrl} />
                </div>
                <div className={styles.pcBottom}>
                    <p className={styles.pcBottomP}>
                        <span>公司：北京天盈九州网络技术有限公司</span>
                        <span>公司地址：北京市朝阳区启阳路4号中轻大厦</span>公司电话：010-606760000
                    </p>
                    <p className={styles.pcBottomP}>
                        <span>凤凰新媒体</span>
                        <span>版权所有</span>
                        <span>Copyright © 2021Phoenix New Media Limited All Right Reserved</span>
                    </p>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Pc);
